import customerIdRegex from '@eneco/common/validation/customerIdRegex';
import { emailValidation } from '@eneco/common/validation/emailRegex';
import phoneNumberRegex from '@eneco/common/validation/phoneNumberRegex';
import { ContactFormRendering } from '@sitecore/types/ContactForm';
import { boolean, object, string } from 'yup';

export const getSchema = (fields: ContactFormRendering['fields'], canHaveBudgetManager: boolean) => {
  const {
    salutationFormField,
    firstNameFormField,
    surnameFormField,
    phoneNumberFormField,
    emailAddressFormField,
    customerIdFormField,
    inquiryTopicFormField,
    inquiryTypeFormField,
    inquiryContentFormField,
    businessNameFormField,
    cityFormField,
    houseNumberFormField,
    postalCodeFormField,
    streetNameFormField,
    hideInquiryTypeFormFieldCheckbox,
  } = fields.formFields;

  return object({
    recaptchaToken: string().required(),
    inquiryTopic: string().required(inquiryTopicFormField.value.requiredMessage),
    inquiryType: !hideInquiryTypeFormFieldCheckbox.value
      ? string().required(inquiryTypeFormField.value.requiredMessage)
      : string(),
    inquiryContent: string().required(inquiryContentFormField.value.requiredMessage),
    salutation: string().required(salutationFormField.value.requiredMessage),
    firstName: string().required(firstNameFormField.value.requiredMessage),
    surnamePreposition: string(),
    surname: string().required(surnameFormField.value.requiredMessage),
    phoneNumber: string()
      .matches(phoneNumberRegex, { message: phoneNumberFormField.value.validationMessage })
      .required(phoneNumberFormField.value.requiredMessage),
    emailAddress: emailValidation({
      emailMessage: emailAddressFormField?.value?.validationMessage,
      requiredMessage: emailAddressFormField?.value?.requiredMessage,
    }),
    customerId: string()
      .optional()
      .matches(customerIdRegex, { message: customerIdFormField.value.validationMessage, excludeEmptyString: true }),
    ...(canHaveBudgetManager ? { authorIsBudgetManager: boolean() } : {}),
    budgetManagerBusiness: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager ? string().required(businessNameFormField.value.requiredMessage) : string(),
    ),
    budgetManagerSalutation: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager ? string().required(salutationFormField.value.requiredMessage) : string(),
    ),
    budgetManagerFirstname: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager ? string().required(firstNameFormField.value.requiredMessage) : string(),
    ),
    budgetManagerSurnamePreposition: string(),
    budgetManagerSurname: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager ? string().required(surnameFormField.value.requiredMessage) : string(),
    ),
    budgetManagerEmailAddress: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager
        ? string()
            .email(emailAddressFormField.value.validationMessage)
            .required(emailAddressFormField.value.requiredMessage)
        : string().email(),
    ),
    budgetManagerPhoneNumber: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager
        ? string()
            .matches(phoneNumberRegex, {
              excludeEmptyString: true,
              message: phoneNumberFormField.value.validationMessage,
            })
            .required(phoneNumberFormField.value.requiredMessage)
        : string(),
    ),
    budgetManagerPostalCode: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager ? string().required(postalCodeFormField.value.requiredMessage) : string(),
    ),
    budgetManagerHouseNumber: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager ? string().required(houseNumberFormField.value.requiredMessage) : string(),
    ),
    budgetManagerHouseNumberSuffix: string(),
    budgetManagerStreetName: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager ? string().required(streetNameFormField.value.requiredMessage) : string(),
    ),
    budgetManagerCity: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager ? string().required(cityFormField.value.requiredMessage) : string(),
    ),
  });
};
